import type { FC } from 'react';
import { CreativeTextsTT } from 'features/cabinet';
import { CabinetTitlePage } from 'components/layout';
import { LinkButton } from 'components/common';
import { Guard, usePermissionGuard } from 'features/login';
import { Add } from '@mui/icons-material';

const CreativeTextsPage: FC = () => {
  const { accessToViewTiktoktext, accessToAddTiktoktext } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToViewTiktoktext} fallback>
      <CabinetTitlePage
        title={'Creative Texts'}
        endAdornment={
          <LinkButton
            to={'/cabinet/tiktok/creative-texts/add'}
            title={'Add text'}
            disabled={!accessToAddTiktoktext}
            startIcon={<Add />}
          />
        }
      />
      <CreativeTextsTT />
    </Guard>
  );
};

export default CreativeTextsPage;
